import { Command } from '@/app/common/base/command'

export class DeclineCardifPremiumCommand extends Command {

    public async run(actionId: string) {
        await this.client.post(`/api/products/cardifao/actions/${actionId}/decline`)
    }

}
